// removed by extract-text-webpack-plugin
module.exports = {"bpXs":"767","bpSm":"991","bpMd":"1199","bpLg":"1399","bpMlg":"1699","bpXmlg":"1700","bpXlg":"1800","bpXxlg":"5000","cBackground":"#f9f8f7","headerHeight":"50","conceptSelectorDesktopHeight":"150","conceptSelectorMobileTrackPercent":"50","conceptSelectorDesktopTrackPercent":"25","conceptContainerDesktopWidth":"600","conceptContainerMobileRight":"75","conceptContainerMobileLeft":"25"};


//////////////////
// WEBPACK FOOTER
// ./src/_variables.scss
// module id = 398
// module chunks = 1